import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Faq from 'components/Common/Faq'
import TextButton from 'LuxKit/Button/TextButton'
import config from 'constants/config'
import Group from 'components/utils/Group'
import { LOYALTY_TERMS_AND_CONDITIONS_PAGE } from 'loyalty/constants/loyaltyRoutes'

const Section = styled(Pane)`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} 0;
  }
`

interface Props {
  slug: string
}

function LoyaltyLandingPageFaqSection(props: Props) {
  const intl = useIntl()
  const { slug } = props

  const headingText = intl.formatMessage({
    id: 'Z5JfDoIPvXvfJrU9mk6k',
    defaultMessage: 'Frequently asked questions',
    description: 'Heading for the loyalty program FAQ section in the loyalty section',
  })
  const readMoreText = intl.formatMessage({
    id: 'LHGg6-yPQa5gDXND1Ezd',
    defaultMessage: 'Read more FAQs',
    description: 'Button to navigate to the full loyalty program FAQ page',
  })

  return <Section background="normal-background">
    <LayoutContainer variant="medium">
      <VerticalSpacer gap={24}>
        <Heading variant="heading3">
          {headingText}
        </Heading>
        <Faq
          slug={slug}
          maxToShow={5}
        />
        <Group direction="horizontal" horizontalAlign="center" gap={12} wrap="wrap">
          <TextButton kind="secondary" to={config.contentLinks.societeFAQs.to} target="_blank" rel="noopener noreferrer">
            {readMoreText}
          </TextButton>
          <TextButton kind="secondary" to={`/${LOYALTY_TERMS_AND_CONDITIONS_PAGE}`} target="_blank" rel="noopener noreferrer">
            {intl.formatMessage({
              id: 'Hv9ISI3fUCpdbtl14WEX',
              defaultMessage: 'Société Terms & Conditions',
              description: 'Button to navigate to the Société terms and conditions page',
            })}
          </TextButton>
        </Group>
      </VerticalSpacer>
    </LayoutContainer>
  </Section>
}

export default LoyaltyLandingPageFaqSection
